import { Api } from "~/api";
import {
  fetchMeta,
  fetchMetaBaltex,
  fetchMetaLendings,
} from "~/redux/action-creaters/meta";
import { checkIsBaltex, checkIsLanding, logTime } from "~/utils/index";
import { baltexPages, farkopPages, landingsPages } from "~/types/pages";
import { setHost, setSiteType } from "~/redux/action-creaters/params";
import { SiteTypes } from "~/redux/reducers/paramsReducer";
import { fetchContactsNew } from "~/redux/action-creaters/contacts";

export default async (
  defaultProps = {},
  store,
  redis,
  ctx,
  url = "",
  getMeta = true,
) => {
  const start = Date.now();
  const reset = Boolean(ctx.query.reset);
  let { host } = ctx.req.headers;
  host = host.replace("localhost:3000", "spb.farkop.ru");
  host = host.replace("farkop-msk.ru", "farkop.ru");
  const isBaltex = checkIsBaltex(host);
  const isLanding = checkIsLanding(host);

  if (isBaltex) {
    store.dispatch(setSiteType(SiteTypes.Baltex));
  } else if (isLanding) {
    store.dispatch(setSiteType(SiteTypes.Landing));
  } else {
    store.dispatch(setSiteType(SiteTypes.Farkop));
  }
  store.dispatch(setHost(host));

  let scripts;
  if (isBaltex) {
    scripts = await Api.baltex.getScripts(redis, reset);
  } else {
    scripts = await Api.content.getScripts(redis, reset);
  }

  if (getMeta) {
    if (isBaltex) {
      await store.dispatch(fetchMetaBaltex(redis, url, reset));
    } else if (isLanding) {
      await store.dispatch(fetchMetaLendings(redis, host, url, reset));
    } else {
      await store.dispatch(fetchMeta(redis, host, url, reset));
    }
  }

  if (url) {
    if (isBaltex) {
      if (!baltexPages.includes(url)) {
        return {
          notFound: true,
        };
      }
    } else if (isLanding) {
      if (!landingsPages.includes(url)) {
        return {
          notFound: true,
        };
      }
    } else if (!farkopPages.includes(url)) {
      return {
        notFound: true,
      };
    }
  }

  await store.dispatch(fetchContactsNew(redis, host.split(".")[0], reset));
  logTime(start, `wrapper, ${url}`);
  return {
    props: {
      ...defaultProps,
      isBaltex,
      isLanding,
      isFarkop: !isBaltex && !isLanding,
      scripts,
      host,
    },
  };
};
